import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
export var AlertBanner = function (_a) {
    var children = _a.children, headline = _a.headline, onClose = _a.onClose, _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.status, status = _c === void 0 ? 'info' : _c;
    if (!children) {
        return null;
    }
    return (React.createElement(Alert, { status: status, size: size, onClose: onClose, "data-testid": "alert-banner" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
            headline && React.createElement(Typography, { weight: "bold" }, headline),
            React.createElement(Typography, { variant: "body-base" }, children))));
};
